import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AdminCard.module.css';
import TitleMain from "../Title/TitleMain";
import TitleSecondary from "../Title/TitleSecondary";

function AdminCard({ lien, titre }) {
    return (
        <div>
                <Link to={lien} className={styles.adminCard}>
                    <h3>{titre}</h3>
                </Link>
        </div>
    );
}

export default AdminCard;
